/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type HotspotExitAnimation = (typeof HotspotExitAnimation)[keyof typeof HotspotExitAnimation]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HotspotExitAnimation = {
  NONE: 'NONE',
  FADE: 'FADE',
} as const
